import { errorHandler } from '@/Config/ErrorHandler';
import { host } from '@branding/config';
import { usePostHog } from 'posthog-js/react';

interface ISetUserMetrics {
	actionType: 'answerQuestion' | 'unfocusedTab' | 'focusedTab' | 'closedTab' | 'beginInvestigation';
	componentType: 'question' | 'investigationContext';
	timeSpent: number;
	sc: string | null;
	questionId?: string;
}
export const useSetUserMetrics = () => {
	const posthog = usePostHog();
	const sessionId = posthog.get_session_id();

	const setUserMetrics = ({ actionType, timeSpent, componentType, sc, questionId = '' }: ISetUserMetrics) => {
		const reqBody = {
			componentType: componentType,
			timeSpent: timeSpent,
			actionType: actionType,
			questionId: questionId,
			sc: sc ?? '',
			sessionId: sessionId,
		};

		try {
			// Relative-safe base (`${host}/api/...`), matching every other call in the app.
			// `new URL()` here threw when host was empty (same-origin / tests).
			fetch(`${host}/api/setUserMetrics`, {
				method: 'POST',
				body: JSON.stringify(reqBody),
				keepalive: true,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res: Response) => {});
		} catch (err) {
			errorHandler(new Error('Error setting metrics'), { err });
			throw new Error('Error setting metrics', { cause: err });
		}
	};
	return { setUserMetrics };
};
